class ArticleContentParser {
  constructor(container) {
    this.container = container;
    this.patterns = [
      {
        regex: /\[Caption\]([\s\S]*?)\[\/Caption\]/gi,
        replace: '<span class="article-caption">$1</span>'
      },
      {
        regex: /\[Quote\]([\s\S]*?)\[\/Quote\]/gi,
        replace: '<blockquote class="article-quote"><p>$1</p></blockquote>'
      }
    ];
  }

  parse() {
    let html = this.container.innerHTML;
    this.patterns.forEach(({ regex, replace }) => {
      html = html.replace(regex, replace);
    });
    this.container.innerHTML = html;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector('.article-template__content');
  if (content) {
    new ArticleContentParser(content).parse();
  }
});
